import styled from 'styled-components'

export const AdvContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  a {
    height: 100%;
  }
  @media screen and (min-width: 1100px) {
    padding-top: 49px;
  }
`

export const BannerImg = styled.img`
  width: 100%;
  height: 100%;
`
